import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Chip, Card, CardContent, Alert } from '@mui/material';

import SubmissionPdfCard from './SubmissionPdfCard';
import { BackflowJobItem } from '../../model';
import axios from '../../../sharedModules/utils/axios.utils';

interface WaterAuthoritySubmissionPdfsSectionProps {
  backflowJobGroupId: string;
}

const WaterAuthoritySubmissionPdfsSection: React.FC<WaterAuthoritySubmissionPdfsSectionProps> = ({
  backflowJobGroupId,
}) => {
  const [approvedItems, setApprovedItems] = useState<BackflowJobItem[]>([]);

  useEffect(() => {
    if (!backflowJobGroupId) return;

    const fetchBackflowJobItems = async () => {
      try {
        const response = await axios.get<{ result: BackflowJobItem[] }>('/backflows/backflow_job_items', {
          params: { 'ransack[backflow_job_group_id_eq]': backflowJobGroupId },
        });
        const items = response.data.result ?? [];
        const approved = items.filter((item) => item.status === 'approved');
        setApprovedItems(approved);
      } catch {
        setApprovedItems([]);
      }
    };

    void fetchBackflowJobItems();
  }, [backflowJobGroupId]);

  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5" fontWeight="700">
            Water Authority Submission PDFs
          </Typography>
          <Chip label={`${approvedItems.length} Items`} color="primary" />
        </Box>
      </Grid>
      {approvedItems.length === 0 ? (
        <Grid item xs={12}>
          <Card elevation={1}>
            <CardContent>
              <Alert severity="info">
                No approved items found for this job group. Items must be approved before submission PDFs can be
                generated.
              </Alert>
            </CardContent>
          </Card>
        </Grid>
      ) : (
        approvedItems.map((item) => (
          <Grid item xs={12} md={4} key={item.id}>
            <SubmissionPdfCard item={item} />
          </Grid>
        ))
      )}
    </>
  );
};

export default WaterAuthoritySubmissionPdfsSection;
